<template>
  <div class="">
    <h4>کلید اشتراک spot player</h4>
    <table class="table table-striped">
      <thead>
      <tr>
        <th scope="col">کلید اشتراک spot player</th>
        <th scope="col">
          <span class="key">
            <button @click="copyKey()" class="btn btn-primary rounded-pill mx-1">کپی</button>
            {{ spotPlayerKey }}
          </span>
        </th>
      </tr>
      </thead>
      <tbody>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  name: "OrderMetaSpotPlayer1",
  props: {
    meta: {
      default: null
    }
  },
  computed: {
    spotPlayerKey() {
      if (this.meta == null) {
        return ''
      }
      return JSON.parse(this.meta.value)['key']
    },
  },
  methods: {
    copyKey() {
      navigator.clipboard.writeText(this.spotPlayerKey);
    }
  }
}
</script>

<style scoped>
.key {
  word-break: break-word;
  font-size: 11px;
}
</style>